import React, {Component, useEffect, useState} from 'react';
import { Link } from "react-router-dom";
import axios from "axios";
import Navbar from "../components/base/Navbar";
import Footer from "../components/base/Footer";
import Contact from "../components/Contact";

const NewsletterYears = () => {

    // years: [{ year: number, visible: boolean }]
    const [years, setYears] = useState([]);
    const [loading, setLoading] = useState(true);

    const token = localStorage.getItem("token");
    const isAdmin = !!token; // einfache Heuristik: Token vorhanden = Admin-Ansicht

    const loadYears = async () => {
        setLoading(true);
        try {
            if (isAdmin) {
                try {
                    const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/admin/newsletter/years`, {
                        withCredentials: false,
                        headers: { Authorization: `Bearer ${token}` },
                    });
                    const rows = Array.isArray(res.data) ? res.data : [];
                    // Erwartet: [{year, visible}]
                    rows.sort((a, b) => b.year - a.year);
                    setYears(rows);
                }catch (e) {
                    if (e?.response?.status === 401 || e?.response?.status === 403) {
                        // Fallback auf PUBLIC:
                        const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/newsletter/years`, {
                            withCredentials: false,
                            headers: {},                    // <<< wichtig: KEIN Authorization!
                        });
                        const list = Array.isArray(res.data) ? res.data : [];
                        list.sort((a, b) => b - a);
                        setYears(list.map((y) => ({ year: y, visible: true })));
                    } else {
                        throw e;
                    }
                }
            } else {
                // Public: nur sichtbare Jahre (als Array<number>)
                const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/newsletter/years`, {
                    withCredentials: false,
                    headers: {},
                });
                const list = Array.isArray(res.data) ? res.data : [];
                list.sort((a, b) => b - a);
                setYears(list.map((y) => ({ year: y, visible: true })));
            }
        } catch {
            // Fallback bei Fehler
            const y = new Date().getFullYear();
            const fallback = [y, y + 1, y + 2].map((yy) => ({ year: yy, visible: false }));
            setYears(fallback);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        let mounted = true;
        (async () => {
            await loadYears();
        })();
        return () => {
            mounted = false;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isAdmin]);

    const toggleVisibility = async (year, currentVisible) => {
        if (!isAdmin) return;
        // Optimistic UI
        setYears((prev) =>
            prev.map((row) =>
                row.year === year ? { ...row, visible: !currentVisible } : row
            )
        );
        try {
            await axios.put(
                `${process.env.REACT_APP_BACKEND_URL}/api/admin/newsletter/years/${year}/visibility`,
                { visible: !currentVisible },
                {
                    // Cookie-Session? -> withCredentials: true
                    withCredentials: false,
                    headers: { Authorization: `Bearer ${token}` },
                }
            );
        } catch (e) {
            // Rollback bei Fehler
            setYears((prev) =>
                prev.map((row) =>
                    row.year === year ? { ...row, visible: currentVisible } : row
                )
            );
            alert("Konnte Sichtbarkeit nicht speichern.");
        }
    };

    return (
        <div>
            <div className="my-4 text-center">
                <h2 className="md:text-6xl text-5xl font-bold drop-shadow-md bg-gradient-to-r from-blue-500 to-blue-800 inline-block text-transparent uppercase bg-clip-text">Newsletter</h2>
                <p className="text-gray-500 text-center font-bold">Erhalte immer die neusten News!</p>
            </div>

            <div className="container promotion-overlay promotion-bg mx-auto my-12 flex items-center justify-center">
                <div className="flex items-center justify-center self-center py-8 md:py-24">
                    <div className="container flex flex-wrap justify-center gap-6 px-6">
                        {loading
                            ? Array.from({ length: 3 }).map((_, i) => (
                                <div
                                    key={i}
                                    className="relative bg-white border-2 border-gray-200 rounded-3xl p-16 drop-shadow-lg animate-pulse"
                                >
                                    <div className="h-10 w-24 mx-auto rounded bg-gray-200" />
                                </div>
                            ))
                            : years.map(({ year, visible }) => (
                                <div key={year} className="flex items-center justify-center w-full">
                                    <div className="relative bg-white border-2 border-gray-200 rounded-3xl content-center py-16 px-28 drop-shadow-lg group w-full max-w-md">
                                        {/* Jahr-Karte klickbar zur Jahresansicht */}
                                        <Link to={`/newsletter/${year}`} className="block text-center">
                                            <h3 className="text-center text-4xl font-bold bg-gradient-to-r from-gray-800 to-gray-500 inline-block text-transparent bg-clip-text">
                                                {year}
                                            </h3>
                                        </Link>

                                        {/* Pfeil Icon (Deko) */}
                                        <div className="absolute bottom-4 right-4 text-white z-20 p-2 bg-blue-400 backdrop-blur-xl rounded-full flex drop-shadow-lg items-center justify-center group-hover:-translate-x-1 group-hover:-translate-y-1 transition-all duration-300">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                className="h-6 w-6"
                                            >
                                                <path d="M7 7h10v10"></path>
                                                <path d="M7 17 17 7"></path>
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                            ))}
                    </div>
                </div>
            </div>

        </div>
    );
}

export default NewsletterYears;



